export const validateCard = ({ value, state }) => {
    // Detecta si el valor es un número
    const numbersOnly = value.replace(/\D/g, '');
    const card = Number(value.replace(/\s/g, ''), 10)
    const isValid = !isNaN(card)
    if (!isValid) return { isValid }

    // Detecta si es American Express
    const isAmericanExpress = /^(34|37)/.test(value)

    // Aplicar el formato deseado (#### ###### #####)
    let formatted = '';
    for (var i = 0; i < numbersOnly.length; i++) {
        if (isAmericanExpress && (i === 4 || i === 10)) {
            formatted += ' '; // Agregar espacio después del primer y segundo grupo
        } else if (!isAmericanExpress && (i % 4 === 0 && i > 0)) {
            formatted += ' '
        }
        formatted += numbersOnly.charAt(i);
    }
    value = formatted
    // console.log(formatted)

    return {
        newValue: value,
        isValid
    }
}

// ? Anterior manera de validar la tarjeta

// const isBackspace = value.length < state.length
// Detecta si el valor es una tarjeta válida
// if (value.replace(/\s/g, '').length % 4 === 0 && value[value.length - 1] !== ' ' && value.length < 19 && !isBackspace) {
//     const newValue = value
//         .replace(/\s/g, '')
//         .replace(/(\d{1,4})/g, (match, p1) => p1 ? p1 + ' ' : p1 + '');
//     value = newValue
//     // console.log(newValue)
// }

export const trimCard = (value) => {
    return value.replace(/\s/g, '')
}


// WEBPACK FOOTER //
// ./src/helpers/card.js